import { render, staticRenderFns } from "./I-0-5__IR-Shareholder.vue?vue&type=template&id=3d850c9f&"
import script from "./I-0-5__IR-Shareholder.vue?vue&type=script&lang=js&"
export * from "./I-0-5__IR-Shareholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports